/* global axios */
import ApiClient from '../ApiClient';

class BookableResourcesAPI extends ApiClient {
  constructor() {
    super('planning/bookable_resources', { accountScoped: true });
  }

  getAll(params = {}) {
    return axios.get(this.url, { params });
  }

  create(data) {
    return axios.post(this.url, { bookable_resource: data });
  }

  update(id, data) {
    if (data.avatar instanceof File) {
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        if (value === undefined || value === null) return;
        formData.append(`bookable_resource[${key}]`, value);
      });
      return axios.patch(`${this.url}/${id}`, formData);
    }

    return axios.patch(`${this.url}/${id}`, { bookable_resource: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  deleteAvatar(id) {
    return axios.delete(`${this.url}/${id}/avatar`);
  }
}

export default new BookableResourcesAPI();
